import React, { memo, useState } from 'react';
import moment from 'moment';
import { Accordion, Card, Row } from "react-bootstrap";
import { AnalyzeRecentSummaryDetail } from './AnalyzeRecentSummaryDetail';

export const AnalayzeRecentSummary = memo(({ data, index, propState }) => {

    const [isOpen, setOpen] = useState(false);
    const onToggle = () => {
        setOpen(!isOpen);
    };

    return (
        <Accordion key={`$accordian${index}`} className='secondary-accord'>
            <Card key={index} className='summary-card' >
                <Card.Header className='summary-header'>
                    <Accordion.Toggle as={Card.Header} eventKey={String(index)} onClick={() => { onToggle()/* ; onShowWorkWindow(!isOpen); */ }}>
                        <Row className='m-0 align-items-center'>
                            <div className='mr-auto summary-text'>
                                {/*  <p className='mb-0 font-weight-bold summary-value-header' >{data.name}</p> */}
                                <p style={{'marginLeft':'60px'}} className='mb-0 font-weight-bold summary-value-header'>{(data && data.worked_day) ? moment(data.worked_day).format('MMMM DD') : null}</p>
                            </div>
                            <div className='text-center' style={{ fontSize: '1.5rem' }}>
                                <span className="mt-2 mr-2 storage-icon-container text-muted">{isOpen ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}</span>
                            </div>
                        </Row>
                    </Accordion.Toggle>
                </Card.Header>
                {isOpen && <Accordion.Collapse eventKey={String(index)}>
                    <Card.Body className='card-grid'>
                        <AnalyzeRecentSummaryDetail isAccordOpen={isOpen} propState={propState} data={data} summaryType='day' />
                    </Card.Body>
                </Accordion.Collapse>}
            </Card>
        </Accordion>
    )
})